/** Reserved binary-frame source; 255 is the existing REST-poller marker. */
export const SIMULATION_FRAME_SHARD = 254;
export const SIMULATION_ACTIVE_STATUSES = ['STARTING', 'RUNNING', 'STOPPING'];
/** Fill at the executable touch, respecting limits and stop activation. */
export function simulationFillPrice(order, quote, triggered) {
    const stop = order.orderType === 'STOP_MARKET' || order.orderType === 'STOP_LIMIT';
    const activated = !stop || triggered || (order.triggerPrice !== null &&
        (order.side === 'BUY' ? quote.ltp >= order.triggerPrice : quote.ltp <= order.triggerPrice));
    if (!activated)
        return { triggered: false, price: null };
    const touch = order.side === 'BUY' ? quote.ask : quote.bid;
    if (!(Number.isFinite(touch) && touch > 0))
        return { triggered: activated, price: null };
    const limited = order.orderType === 'LIMIT' || order.orderType === 'STOP_LIMIT';
    if (limited && (order.limitPrice === null ||
        (order.side === 'BUY' ? touch > order.limitPrice : touch < order.limitPrice))) {
        return { triggered: activated, price: null };
    }
    return { triggered: activated, price: touch };
}
//# sourceMappingURL=simulation.js.map